import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="w-full bg-[#F2C612] pt-12 md:pt-16 pb-6 md:pb-8 px-4 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        {/* Top section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 md:mb-12 gap-6 md:gap-0">
          {/* Logo */}
          <div>
            <img
              src="https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/650ae9be84a336a036b166bc2c8b5a82.png"
              alt="BEST Building Supplies"
              className="h-12 md:h-14 w-auto object-contain"
            />
          </div>

          {/* Newsletter */}
          <div className="w-full md:w-auto">
            <p
              className="text-[14px] md:text-[15px] text-[#1A1A1A] font-semibold mb-3"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Get product updates and tips
            </p>
            <form
              data-readdy-form
              id="footer-newsletter"
              action="https://readdy.ai/api/public/form/submit/footer-newsletter"
              method="POST"
              className="flex flex-col md:flex-row gap-3"
              onSubmit={(e) => {
                e.preventDefault();
                const form = e.currentTarget;
                const formData = new FormData(form);
                const email = formData.get('email');
                
                if (!email) {
                  alert('Please enter your email address');
                  return;
                }

                fetch(form.action, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: new URLSearchParams(formData as any).toString(),
                })
                  .then((response) => {
                    if (response.ok) {
                      alert('Thank you for subscribing!');
                      form.reset();
                    } else {
                      alert('Something went wrong. Please try again.');
                    }
                  })
                  .catch(() => {
                    alert('Something went wrong. Please try again.');
                  });
              }}
            >
              <input
                type="email"
                name="email"
                placeholder="Your email"
                required
                className="px-4 py-3 rounded text-[14px] md:text-[15px] border-2 border-[#1A1A1A] focus:outline-none focus:ring-2 focus:ring-[#1A1A1A] w-full md:w-[280px]"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              />
              <button
                type="submit"
                className="bg-[#1A1A1A] text-white px-6 py-3 rounded text-[14px] md:text-[15px] font-semibold hover:bg-[#333333] transition-colors duration-300 whitespace-nowrap cursor-pointer w-full md:w-auto h-[48px] flex items-center justify-center"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Navigation links */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-8 md:mb-12">
          <div>
            <h4
              className="text-[15px] md:text-[16px] font-bold text-[#1A1A1A] mb-3 md:mb-4"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Products
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  onClick={() => navigate('/products/tile-adhesive')}
                  className="text-[13px] md:text-[14px] text-[#1A1A1A] hover:underline cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  Tile Adhesive
                </a>
              </li>
              <li>
                <a
                  onClick={() => navigate('/products/grout')}
                  className="text-[13px] md:text-[14px] text-[#1A1A1A] hover:underline cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  Grout
                </a>
              </li>
              <li>
                <a
                  onClick={() => navigate('/products/paint')}
                  className="text-[13px] md:text-[14px] text-[#1A1A1A] hover:underline cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  Paint &amp; Coatings
                </a>
              </li>
              <li>
                <a
                  onClick={() => navigate('/products')}
                  className="text-[13px] md:text-[14px] text-[#1A1A1A] hover:underline cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  Bonding Liquid
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4
              className="text-[15px] md:text-[16px] font-bold text-[#1A1A1A] mb-3 md:mb-4"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Company
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  onClick={() => navigate('/about')}
                  className="text-[13px] md:text-[14px] text-[#1A1A1A] hover:underline cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  onClick={() => navigate('/contact')}
                  className="text-[13px] md:text-[14px] text-[#1A1A1A] hover:underline cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4
              className="text-[15px] md:text-[16px] font-bold text-[#1A1A1A] mb-3 md:mb-4"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Resources
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  onClick={() => navigate('/learn')}
                  className="text-[13px] md:text-[14px] text-[#1A1A1A] hover:underline cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  Video Tutorials
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4
              className="text-[15px] md:text-[16px] font-bold text-[#1A1A1A] mb-3 md:mb-4"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              For Trade
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  onClick={() => navigate('/contact')}
                  className="text-[13px] md:text-[14px] text-[#1A1A1A] hover:underline cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  Become a Stockist
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom section */}
        <div className="border-t-2 border-[#1A1A1A] pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p
            className="text-[12px] md:text-[13px] text-[#1A1A1A]"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            © 2024 BEST Building Supplies. All rights reserved.
          </p>
          <div className="flex gap-4 md:gap-6">
            <a
              href="#"
              className="w-8 h-8 md:w-10 md:h-10 bg-[#1A1A1A] rounded-full flex items-center justify-center hover:bg-[#333333] transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-facebook-fill text-[#F2C612] text-[16px] md:text-[18px]"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 md:w-10 md:h-10 bg-[#1A1A1A] rounded-full flex items-center justify-center hover:bg-[#333333] transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-instagram-line text-[#F2C612] text-[16px] md:text-[18px]"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 md:w-10 md:h-10 bg-[#1A1A1A] rounded-full flex items-center justify-center hover:bg-[#333333] transition-colors duration-300 cursor-pointer"
            >
              <i className="ri-youtube-fill text-[#F2C612] text-[16px] md:text-[18px]"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}